import gql from "graphql-tag";

export const createInvite = gql`
  mutation createInvite(
    $input: CreateInviteInput!) {
    createInvite(input: $input) {
      project {
        id
        invites {
            author {
              id
              name
              profilePictureUrl
            }
            invitedAt
            role
            status
            code
            email
        }
      }
    }
  }
`;

export const createInviteOptions = {
  name: "createInvite",
};
